import React from "react";
import "./ourservices3.css";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Ourservices3 = () => {
  const { t } = useTranslation("global");
  const { lang } = useParams();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <section className="contact-section">
      <h3>{t("ourServices.section3.heading")}</h3>
      <h2>
        {t("ourServices.section3.heading1")}
        <br></br>
        {t("ourServices.section3.heading2")}
      </h2>
      <Link to={`/${lang}/ContactUs`} onClick={scrollToTop}>
        <button className="contact-button">
          {t("ourServices.section3.button")}
        </button>
      </Link>
    </section>
  );
};

export default Ourservices3;
